module.exports = __webpack_public_path__ + "static/media/feed.cebf46ee.png";